"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _InputAdornment = _interopRequireDefault(require("@mui/material/InputAdornment"));

var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));

var _styles = require("@mui/styles");

var _loupe = _interopRequireDefault(require("../../shared/themes/assets/img/loupe.png"));

var _styledComponents = require("./styledComponents");

var _excluded = ["onChange", "value", "label", "inputProps", "placeholderTxt", "withBorder", "gotoSearchResults"];

var SearchInput = function SearchInput(_ref) {
  var onChange = _ref.onChange,
      value = _ref.value,
      label = _ref.label,
      inputProps = _ref.inputProps,
      placeholderTxt = _ref.placeholderTxt,
      withBorder = _ref.withBorder,
      gotoSearchResults = _ref.gotoSearchResults,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var theme = (0, _styles.useTheme)();
  var isSmallScreen = (0, _material.useMediaQuery)(theme.breakpoints.down('md'));

  var onSearchHandler = function onSearchHandler(event) {
    onChange(event.target.value);
  };

  var handleClearSearch = function handleClearSearch() {
    onChange('');
  };

  return /*#__PURE__*/_react.default.createElement(_styledComponents.StyledFormControl, Object.assign({
    $withborder: withBorder
  }, rest), label && /*#__PURE__*/_react.default.createElement(_styledComponents.StyledInputLabel, {
    shrink: true,
    htmlFor: "input"
  }, label), /*#__PURE__*/_react.default.createElement(_styledComponents.InputSearch, Object.assign({
    placeholder: placeholderTxt,
    onChange: onSearchHandler,
    value: value,
    endAdornment: value && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
      position: "end"
    }, !isSmallScreen && /*#__PURE__*/_react.default.createElement(_styledComponents.StyledSearchIconButton, {
      "aria-label": "launch search",
      onClick: gotoSearchResults,
      edge: "end"
    }, /*#__PURE__*/_react.default.createElement(_styledComponents.StyledBtnSearchLabel, null, "Recherche"), /*#__PURE__*/_react.default.createElement("img", {
      src: _loupe.default,
      alt: "Search Icon",
      width: "20",
      height: "20"
    })), isSmallScreen && /*#__PURE__*/_react.default.createElement(_styledComponents.StyledLoupeImg, {
      src: _loupe.default,
      alt: "Search Icon",
      width: "20",
      height: "20",
      onClick: gotoSearchResults,
      "aria-hidden": "true"
    })), /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
      position: "end"
    }, /*#__PURE__*/_react.default.createElement(_styledComponents.StyledIconButton, {
      "aria-label": "clear search",
      onClick: handleClearSearch,
      edge: "end"
    }, /*#__PURE__*/_react.default.createElement(_Close.default, {
      sx: !isSmallScreen ? {
        fontSize: 20
      } : {
        fontSize: 10
      }
    }))))
  }, inputProps)), !value && /*#__PURE__*/_react.default.createElement(_styledComponents.WrapperSearchIcon, null, !isSmallScreen && /*#__PURE__*/_react.default.createElement(_styledComponents.Divider, null), /*#__PURE__*/_react.default.createElement("img", {
    src: _loupe.default,
    alt: "Search Icon",
    width: "20",
    height: "20"
  })));
};

SearchInput.defaultProps = {
  onChange: function onChange() {},
  gotoSearchResults: function gotoSearchResults() {},
  inputProps: {},
  placeholderTxt: 'Chercher',
  withBorder: true,
  label: ''
};
var _default = SearchInput;
exports.default = _default;